import { Link } from "react-router-dom";

import { getAbcFitnessBrandLogoHref } from "@/lib/portal/abc-fitness-brand";

type AbcFitnessBrandLogoTheme = "dark" | "light";

interface AbcFitnessBrandLogoProps {
  to?: string;
  testId?: string;
  theme?: AbcFitnessBrandLogoTheme;
  className?: string;
}

export function AbcFitnessBrandLogo({
  to = "/",
  testId = "abc-fitness-brand-logo",
  theme = "light",
  className,
}: AbcFitnessBrandLogoProps) {
  const logoClassName = [
    "abc-brand-logo",
    theme === "dark" ? "abc-brand-logo--on-dark" : "abc-brand-logo--on-light",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const img = (
    <img
      src={getAbcFitnessBrandLogoHref()}
      alt="ABC Fitness"
      className="abc-brand-logo__img"
      width={140}
      height={26}
      decoding="async"
    />
  );

  if (!to) {
    return (
      <span className={logoClassName} data-testid={testId}>
        {img}
      </span>
    );
  }

  return (
    <Link
      to={to}
      className={logoClassName}
      data-testid={testId}
      aria-label="ABC Fitness developer portal home"
    >
      {img}
    </Link>
  );
}
